// App Sections
const MAP_EXPLORER = 'mex'
const OWNER_REVEAL = 'ore'
const MAP_BUILDER = 'mbl'
const TENANT_FINDER = 'ten'
const CHROME_BAR = 'chr'

const CHROME_BAR_IDS = {
  bar: `${CHROME_BAR}-bar`,
  home: `${CHROME_BAR}-home`,
  'map-explorer': `${CHROME_BAR}-map-explorer`,
  'tenant-finder': `${CHROME_BAR}-tenant-finder`,
  'owner-reveal': `${CHROME_BAR}-owner-reveal`,
  'map-builder': `${CHROME_BAR}-map-builder`,
  'help-center': `${CHROME_BAR}-help-center`,
  support: `${CHROME_BAR}-support`,
  'feature-flags': `${CHROME_BAR}-feature-flags`,
  'user-settings': `${CHROME_BAR}-user-settings`,
}

const MAP_EXPLORER_IDS = {
  // Map view
  'search-bar': `${MAP_EXPLORER}-search-bar`,
  'map-pins-tool': `${MAP_EXPLORER}-map-pins-tool`,
  'map-layers-tool': `${MAP_EXPLORER}-map-layers-tool`,
  'custom-area-tool': `${MAP_EXPLORER}-custom-area-tool`,
  // Selected location/address
  'create-custom-report-tab': `${MAP_EXPLORER}-create-custom-report-tab`,
  'property-records-tab': `${MAP_EXPLORER}-property-records-tab`,
  'zoning-tab': `${MAP_EXPLORER}-zoning-tab`,
  'radius-rings-trade-area-insights-tab': `${MAP_EXPLORER}-radius-rings-trade-area-insights-tab`,
  'drive-time-trade-area-insights-tab': `${MAP_EXPLORER}-drive-time-trade-area-insights-tab`,
  'demographics-tab': `${MAP_EXPLORER}-demographics-tab`,
  'car-traffic-insights-tab': `${MAP_EXPLORER}-car-traffic-insights-tab`,
  'true-trade-area-insights-tab': `${MAP_EXPLORER}-true-trade-area-insights-tab`,
  'location-visits-tab': `${MAP_EXPLORER}-location-visits-tab`,
  'area-visits-tab': `${MAP_EXPLORER}-area-visits-tab`,
  'brand-rank-tab': `${MAP_EXPLORER}-brand-rank-tab`,
  'category-rank-tab': `${MAP_EXPLORER}-category-rank-tab`,
  'shopping-center-overview-tab': `${MAP_EXPLORER}-shopping-center-overview-tab`,
  'save-button': `${MAP_EXPLORER}-save-button`,
  'compare-toggle': `${MAP_EXPLORER}-compare-toggle`,
  'advanced-filters-toggle': `${MAP_EXPLORER}-advanced-filters-toggle`,
  'add-location-button': `${MAP_EXPLORER}-add-location-button`,
  'parent-parcel': `${MAP_EXPLORER}-parent-parcel`,
  'nearby-locations': `${MAP_EXPLORER}-nearby-locations`,
  'locations-results-list': `${MAP_EXPLORER}-locations-results-list`,
  'shopping-centers-results-list': `${MAP_EXPLORER}-shopping-centers-results-list`,
  'address-results-list': `${MAP_EXPLORER}-address-results-list`,
  'other-results-list': `${MAP_EXPLORER}-other-results-list`,
  'nearby-matches-button': `${MAP_EXPLORER}-nearby-matches-button`,
  'within-parcels-button': `${MAP_EXPLORER}-within-parcels-button`,
}

const OWNER_REVEAL_IDS = {
  // Map view
  'search-bar': `${OWNER_REVEAL}-search-bar`,
  'search-type': `${OWNER_REVEAL}-search-type`,
  'map-layers-tool': `${OWNER_REVEAL}-map-layers-tool`,
  'custom-area-tool': `${OWNER_REVEAL}-custom-area-tool`,
  // Parcels
  'parcel-reported-owners-tab': `${OWNER_REVEAL}-parcel-reported-owners-tab`,
  'parcel-property-records-tab': `${OWNER_REVEAL}-parcel-property-records-tab`,
  'parcel-zoning-tab': `${OWNER_REVEAL}-parcel-zoning-tab`,
  // Entities
  'entity-owner-summary-insights-tab': `${OWNER_REVEAL}-entity-owner-summary-insights-tab`,
  'entity-owner-contacts-insights-tab': `${OWNER_REVEAL}-entity-owner-contacts-insights-tab`,
  'entity-related-entities-insights-tab': `${OWNER_REVEAL}-entity-related-entities-insights-tab`,
  'entity-porfolio-summary-insights-tab': `${OWNER_REVEAL}-entity-porfolio-summary-insights-tab`,
  'entity-parcels-insights-tab': `${OWNER_REVEAL}-entity-parcels-insights-tab`,
  'entity-acquisition-history-tab': `${OWNER_REVEAL}-entity-acquisition-history-tab`,
  'entity-root-entities-insights-tab': `${OWNER_REVEAL}-entity-root-entities-insights-tab`,
  // Graph map
  'graph-map-tab': `${OWNER_REVEAL}-graph-map-tab`,
  'graph-legend-direct': `${OWNER_REVEAL}-graph-legend-direct`,
  'graph-legend-related': `${OWNER_REVEAL}-graph-legend-related`,
  'graph-legend-organization': `${OWNER_REVEAL}-graph-legend-organization`,
  'graph-legend-person-node': `${OWNER_REVEAL}-graph-legend-person-node`,
  'graph-legend-parcel-node': `${OWNER_REVEAL}-graph-legend-parcel-node`,
} as const

const MAP_BUILDER_IDS = {
  'add-me-later': `${MAP_BUILDER}-add-me-later`,
}

const TENANT_FINDER_IDS = {
  'change-location-button': `${TENANT_FINDER}-change-location-button`,
  'brand-synergy-filter': `${TENANT_FINDER}-brand-synergy-filter`,
  'demographics-filter': `${TENANT_FINDER}-demographics-filter`,
  'columns-filter': `${TENANT_FINDER}-columns-filter`,
  'download-button': `${TENANT_FINDER}-download-button`,
  'print-button': `${TENANT_FINDER}-print-button`,
  'brand-column': `${TENANT_FINDER}-brand-column`,
  'contact-info-column': `${TENANT_FINDER}-contact-info-column`,
  'property-type-column': `${TENANT_FINDER}-property-type-column`,
  'brand-category-column': `${TENANT_FINDER}-brand-category-column`,
  'avg-rating-column': `${TENANT_FINDER}-avg-rating-column`,
  'nearest-location-column': `${TENANT_FINDER}-nearest-location-column`,
  'brand-synergy-score-column': `${TENANT_FINDER}-brand-synergy-score-column`,
  'demographics-score-column': `${TENANT_FINDER}-demographics-score-column`,
  'overall-score-column': `${TENANT_FINDER}-overall-score-column`,
  'score-report-column': `${TENANT_FINDER}-score-report-column`,
  'filters-container': `${TENANT_FINDER}-filters-container`,
} as const

export const COMMANDAI_IDS_MAP = {
  mapExplorer: MAP_EXPLORER_IDS,
  ownerReveal: OWNER_REVEAL_IDS,
  mapBuilder: MAP_BUILDER_IDS,
  tenantFinder: TENANT_FINDER_IDS,
  chromeBar: CHROME_BAR_IDS,
} as const
